/** Internal sentinel path — forces ServerErrorPage during SSR error recovery. */
export const SERVER_ERROR_SENTINEL_PATH = '/__ssr_server_error__'
